import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Dialog from "@visa/vds/dialog";
import DialogCardBody from "@visa/vds/dialog-card-body";
import DialogCardFooter from "@visa/vds/dialog-card-footer";
import DialogCardHead from "@visa/vds/dialog-card-head";
import DialogCardHeadIcon from "@visa/vds/dialog-card-head-icon";
import DialogCardHeadTitle from "@visa/vds/dialog-card-head-title";
import Icon from "@visa/vds/icon";
import React from "react";

const MCSConfirmDialog = (props) => {
  const titleId = props.confirmDialog.id
    ? "dialog-title-" + props.confirmDialog.id
    : "dialog-title-default";
  const type = props.confirmDialog.type ? props.confirmDialog.type : "default";
  const confirmHandler = () => {
    props.confirmHandler(props.confirmDialog.data, props.alertObj);
    props.setConfirmDialog({ ...props.confirmDialog, open: false });
  };
  return (
    <Dialog
      includeDefaultStyles={true}
      aria-describedby="dialog-description"
      onExit={() =>
        props.setConfirmDialog({ ...props.confirmDialog, open: false })
      }
      open={props.confirmDialog.open}
      titleId={titleId}
      type={type}
      scrollDisabled={false}
    >
      <DialogCardHead>
        <DialogCardHeadIcon>
          <Icon name={type} resolution="low" />
        </DialogCardHeadIcon>
        <DialogCardHeadTitle id={titleId}>
          {" "}
          {props.confirmDialog.title}
        </DialogCardHeadTitle>
      </DialogCardHead>
      <DialogCardBody id="dialog-description">
        <div
          dangerouslySetInnerHTML={{ __html: props.confirmDialog.message }}
        ></div>
      </DialogCardBody>
      <DialogCardFooter>
        <ButtonGroup direction="right">
          <ButtonText
            colorScheme={props.confirmDialog.leftButtonColorScheme ? props.confirmDialog.leftButtonColorScheme : "secondary"}
            onClick={confirmHandler}>
            {props.confirmDialog.confirmButtonText
              ? props.confirmDialog.confirmButtonText
              : "Yes"}
          </ButtonText>
          <ButtonText
            colorScheme={props.confirmDialog.rightButtonColorScheme ? props.confirmDialog.rightButtonColorScheme : "secondary"}
            onClick={() =>
              props.setConfirmDialog({ ...props.confirmDialog, open: false })
            }
          >
            {props.confirmDialog.rightButtonText ? props.confirmDialog.rightButtonText : "Cancel"}
          </ButtonText>
        </ButtonGroup>
      </DialogCardFooter>
    </Dialog>
  );
};
export default MCSConfirmDialog;
